import { SectionsKey } from '~/constants/enum';

const PageStruct = {
    id: 'profile-information',
    useLayout: true,
    children: [{ id: 'profile-information', order: 1, dataKey: SectionsKey.ProfileInformation }]
};

export default PageStruct;
